<template>
  <div class="content-charts">
    <div class="chart">
      <DxChart
        id="irrigation_time"
        ref="chart1"
        :data-source="data"
        palette="Material"
        @legend-click="onLegendClick"
        @file-saving="onFileSaving"
      >
        <DxCommonSeriesSettings
          type="line"
          argument-field="ddt"
        />
        <DxSeries
          :value-field="TO_FIXED_DECIMALS_IN_GRAPHICS
            ? 'irrigation_volume_fixed' : 'irrigation_volume'"
        />
        <DxValueAxis
          :show-zero="true"
          position="left"
        >
          <DxTitle text="Riego (mm / d) " />
        </DxValueAxis>
        <DxArgumentAxis
          :value-margins-enabled="true"
          title="Tiempo (días después de trasplante)"
        />

        <DxLegend
          :visible="false"
          vertical-alignment="bottom"
          horizontal-alignment="center"
          item-text-position="right"
        />
        <DxTitle :text="$t('result.irrigation.vol_daily')" />
        <DxTooltip
          :enabled="true"
          :z-index="999999"
          :customize-tooltip="customizeTooltip"
        />
        <DxExport
          :enabled="true"
          :file-name="`${resultProject.name} - Riego - Volumen diario de riego`"
        />
        <DxScrollBar :visible="true" />
        <DxZoomAndPan argument-axis="both" />
      </DxChart>
    </div>
    <div class="chart">
      <DxChart
        id="accumulated_irrigation_volume"
        ref="chart2"
        :data-source="data"
        palette="Material"
        @legend-click="onLegendClick"
        @file-saving="onFileSaving"
      >
        <DxCommonSeriesSettings
          type="line"
          argument-field="ddt"
        />
        <DxSeries
          :value-field="TO_FIXED_DECIMALS_IN_GRAPHICS
            ? 'accumulated_irrigation_volume_fixed' : 'accumulated_irrigation_volume'"
        />
        <DxValueAxis
          :show-zero="true"
          position="left"
        >
          <DxTitle text="Riego (mm)" />
        </DxValueAxis>
        <DxArgumentAxis
          :value-margins-enabled="true"
          title="Tiempo (días después de trasplante)"
        />

        <DxLegend
          :visible="false"
          vertical-alignment="bottom"
          horizontal-alignment="center"
          item-text-position="right"
        />
        <DxTitle :text="$t('result.irrigation.vol_acum')" />
        <DxTooltip
          :enabled="true"
          :z-index="999999"
          :customize-tooltip="customizeTooltipAcum"
        />
        <DxExport
          :enabled="true"
          :file-name="`${resultProject.name} - Riego - Volumen de riego acumulado`"
        />
        <DxScrollBar :visible="true" />
        <DxZoomAndPan argument-axis="both" />
      </DxChart>
    </div>

    <div
      v-if="keyName === '/detailInformation/'"
      class="chart"
    >
      <DxChart
        id="eto"
        ref="chart3"
        :data-source="data"
        palette="Material"
        @legend-click="onLegendClick"
        @file-saving="onFileSaving"
      >
        <DxCommonSeriesSettings
          type="line"
          argument-field="ddt"
        />
        <DxSeries
          :value-field="TO_FIXED_DECIMALS_IN_GRAPHICS
            ? 'irrigation_eto_fixed' : 'irrigation_eto'"
        />
        <DxValueAxis
          :show-zero="true"
          position="left"
        >
          <DxTitle text="ETo (mm/d)" />
        </DxValueAxis>
        <DxArgumentAxis
          :value-margins-enabled="true"
          title="Tiempo (días después de trasplante)"
        />
        <DxLegend
          :visible="false"
          vertical-alignment="bottom"
          horizontal-alignment="center"
          item-text-position="right"
        />
        <DxTitle :text="'ETo (mm/d)'" />
        <DxTooltip
          :enabled="true"
          :z-index="999999"
          :customize-tooltip="customizeTooltipETo"
        />
        <DxExport
          :enabled="true"
          :file-name="`${resultProject.name} - Riego - ETo`"
        />
        <DxScrollBar :visible="true" />
        <DxZoomAndPan argument-axis="both" />
      </DxChart>
    </div>
    <div
      v-if="keyName === '/detailInformation/'"
      class="chart"
    >
      <DxChart
        id="kc"
        ref="chart4"
        :data-source="data"
        palette="Material"
        @legend-click="onLegendClick"
        @file-saving="onFileSaving"
      >
        <DxCommonSeriesSettings
          type="line"
          argument-field="ddt"
        />
        <DxSeries
          :value-field="TO_FIXED_DECIMALS_IN_GRAPHICS
            ? 'irrigation_kc_fixed' : 'irrigation_kc'"
        />
        <DxValueAxis
          :show-zero="true"
          position="left"
        >
          <DxTitle text="kc" />
        </DxValueAxis>
        <DxArgumentAxis
          :value-margins-enabled="true"
          title="Tiempo (días después de trasplante)"
        />

        <DxLegend
          :visible="false"
          vertical-alignment="bottom"
          horizontal-alignment="center"
          item-text-position="right"
        />
        <DxTitle :text="'kc'" />
        <DxTooltip
          :enabled="true"
          :z-index="999999"
          :customize-tooltip="customizeTooltipKc"
        />
        <DxExport
          :enabled="true"
          :file-name="`${resultProject.name} - Riego - kc`"
        />
        <DxScrollBar :visible="true" />
        <DxZoomAndPan argument-axis="both" />
      </DxChart>
    </div>
    <div
      v-if="keyName === '/detailInformation/'"
      class="chart"
    >
      <DxChart
        id="etc"
        ref="chart5"
        :data-source="data"
        palette="Material"
        @legend-click="onLegendClick"
        @file-saving="onFileSaving"
      >
        <DxCommonSeriesSettings
          type="line"
          argument-field="ddt"
        />
        <DxSeries
          :value-field="TO_FIXED_DECIMALS_IN_GRAPHICS
            ? 'irrigation_etc_day_fixed' : 'irrigation_etc_day'"
        />
        <DxValueAxis
          :show-zero="true"
          position="left"
        >
          <DxTitle text="ETc (mm/d)" />
        </DxValueAxis>
        <DxArgumentAxis
          :value-margins-enabled="true"
          title="Tiempo (días después de trasplante)"
        />

        <DxLegend
          :visible="false"
          vertical-alignment="bottom"
          horizontal-alignment="center"
          item-text-position="right"
        />
        <DxTitle :text="'ETc (mm/d)'" />
        <DxTooltip
          :enabled="true"
          :z-index="999999"
          :customize-tooltip="customizeTooltipETc"
        />
        <DxExport
          :enabled="true"
          :file-name="`${resultProject.name} - Riego - ETc`"
        />
        <DxScrollBar :visible="true" />
        <DxZoomAndPan argument-axis="both" />
      </DxChart>
    </div>
    <div
      v-if="DEVICE_PLATFORM !== 'android'"
      class="controls-pane"
      style="width: 100%"
    >
      <DxButton
        id="export"
        style="background-color: #616B7C; padding: 0.5rem;"
        icon="export"
        type="default"
        :text="$t('exportGraphs')"
        @click="keyName === '/detailInformation/'
          ? onClickExport()
          : onClickExportPart1()"
      />
    </div>
  </div>
</template>
<script>
import {
  DxChart,
  DxSeries,
  DxArgumentAxis,
  DxCommonSeriesSettings,
  DxLegend,
  DxTitle,
  DxTooltip,
  DxScrollBar,
  DxZoomAndPan,
  DxExport, DxValueAxis,
} from 'devextreme-vue/chart';
import moment from 'moment';
import DxButton from 'devextreme-vue/button';
import { exportWidgets } from 'devextreme/viz/export';
import { mapState } from 'vuex';
import { DEVICE_PLATFORM, NUMBER_OF_DECIMALS, TO_FIXED_DECIMALS_IN_GRAPHICS } from '../../../js/constants';

export default {
  name: 'TimelineGraph',
  components: {
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxCommonSeriesSettings,
    DxLegend,
    DxTitle,
    DxTooltip,
    DxScrollBar,
    DxZoomAndPan,
    DxExport,
    DxValueAxis,
    DxButton,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    volIrr: {
      type: Array,
      default: () => [],
    },
    volAcum: {
      type: Array,
      default: () => [],
    },
    eto: {
      type: Array,
      default: () => [],
    },
    kc: {
      type: Array,
      default: () => [],
    },
    etc: {
      type: Array,
      default: () => [],
    },
    keyName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      TO_FIXED_DECIMALS_IN_GRAPHICS,
      NUMBER_OF_DECIMALS,
      DEVICE_PLATFORM,
    };
  },
  computed: {
    ...mapState('Result', [
      'resultProject',
    ]),
  },
  methods: {
    customizeTooltip(pointInfo) {
      const strDate = this.data[pointInfo.argument].date;
      const [day, month, year] = strDate.split('/');
      const date = new Date(+year, month - 1, +day);
      return {
        html: `<div><div class='tooltip-header'></div><div class='tooltip-body'>
          <span class='bold'>${this.$t('result.fertigation.date')}: </span>${moment(date).format('DD-MM-YYYY')}
          </span> </div>
          <span class="bold"> ${this.$t('result.irrigation.vol_irr')}: </span> ${Number(pointInfo.valueText).toFixed(this.NUMBER_OF_DECIMALS)}
        </span> </div></div></div>`,
      };
    },
    customizeTooltipAcum(pointInfo) {
      const strDate = this.data[pointInfo.argument].date;
      const [day, month, year] = strDate.split('/');
      const date = new Date(+year, month - 1, +day);
      return {
        html: `<div><div class='tooltip-header'></div><div class='tooltip-body'>
          <span class='bold'>${this.$t('result.fertigation.date')}: </span>${moment(date).format('DD-MM-YYYY')}
          </span> </div>
          <span class="bold">${this.$t('result.irrigation.vol_acum')}: </span> ${Number(pointInfo.valueText).toFixed(this.NUMBER_OF_DECIMALS)}
        </span> </div></div></div>`,
      };
    },
    customizeTooltipETo(pointInfo) {
      const strDate = this.data[pointInfo.argument].date;
      const [day, month, year] = strDate.split('/');
      const date = new Date(+year, month - 1, +day);
      return {
        html: `<div><div class='tooltip-header'></div><div class='tooltip-body'>
          <span class='bold'>${this.$t('result.fertigation.date')}: </span>${moment(date).format('DD-MM-YYYY')}
          </span> </div>
          <span class="bold">ETo: </span> ${Number(pointInfo.valueText).toFixed(this.NUMBER_OF_DECIMALS)}
        </span> </div></div></div>`,
      };
    },
    customizeTooltipKc(pointInfo) {
      const strDate = this.data[pointInfo.argument].date;
      const [day, month, year] = strDate.split('/');
      const date = new Date(+year, month - 1, +day);
      return {
        html: `<div><div class='tooltip-header'></div><div class='tooltip-body'>
          <span class='bold'>${this.$t('result.fertigation.date')}: </span>${moment(date).format('DD-MM-YYYY')}
          </span> </div>
          <span class="bold">kc: </span> ${Number(pointInfo.valueText).toFixed(this.NUMBER_OF_DECIMALS)}
        </span> </div></div></div>`,
      };
    },
    customizeTooltipETc(pointInfo) {
      const strDate = this.data[pointInfo.argument].date;
      const [day, month, year] = strDate.split('/');
      const date = new Date(+year, month - 1, +day);
      return {
        html: `<div><div class='tooltip-header'></div><div class='tooltip-body'>
          <span class='bold'>${this.$t('result.fertigation.date')}: </span>${moment(date).format('DD-MM-YYYY')}
          </span> </div>
          <span class="bold">ETc: </span> ${Number(pointInfo.valueText).toFixed(this.NUMBER_OF_DECIMALS)}
        </span> </div></div></div>`,
      };
    },
    onLegendClick({ target: series }) {
      if (series.isVisible()) {
        series.hide();
      } else {
        series.show();
      }
    },
    onClickExportPart1() {
      const chart1 = this.$refs.chart1.instance;
      const chart2 = this.$refs.chart2.instance;
      if (DEVICE_PLATFORM === 'android') {
        this.$refs.chart1.instance.exportTo('Riego - Volumen diario de riego', 'png');
        this.$refs.chart2.instance.exportTo('Riego - Volumen de riego acumulado', 'png');
      } else {
        exportWidgets([[chart1, chart2]], {
          fileName: 'RESULTADOS RIEGO',
          format: 'PNG',
        });
      }
    },
    onClickExport() {
      const chart1 = this.$refs.chart1.instance;
      const chart2 = this.$refs.chart2.instance;
      const chart3 = this.$refs.chart3.instance;
      const chart4 = this.$refs.chart4.instance;
      const chart5 = this.$refs.chart5.instance;

      if (DEVICE_PLATFORM === 'android') {
        this.$refs.chart1.instance.exportTo(`${this.resultProject.name} - Riego - Volumen diario de riego`, 'png');
        this.$refs.chart2.instance.exportTo(`${this.resultProject.name} - Riego - Volumen de riego acumulado`, 'png');
        this.$refs.chart3.instance.exportTo(`${this.resultProject.name} - Riego - ETo`, 'png');
        this.$refs.chart4.instance.exportTo(`${this.resultProject.name} - Riego - kc`, 'png');
        this.$refs.chart5.instance.exportTo(`${this.resultProject.name} - Riego - ETc`, 'png');
      } else {
        exportWidgets([[chart1, chart2, chart3, chart4, chart5]], {
          fileName: `${this.resultProject.name} - RESULTADOS RIEGO (INFORMACIÓN DETALLADA)`,
          format: 'PNG',
        });
      }
    },
    onFileSaving(e) {
      if (DEVICE_PLATFORM === 'android') {
        const { name } = this.resultProject;
        cordova.plugins.saveDialog.saveFile(e.data, `${this.resultProject.name} - ${e.fileName}.${e.format}`).then((uri) => {
          console.info('The file has been successfully saved to', uri);
        }).catch((reason) => {
          console.warn(reason);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../css/mixins";
.content-charts {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.chart {
  padding-bottom: 4rem;
  padding-left: 1rem;
  padding-right: 1rem;
  flex-basis: 100%;
  @include md {
    flex-basis: 45%;
  }
}
</style>
